function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "X Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "(C)-Candidate-Card-Menu-",
  transform: "translate(-22.000000, -166.000000)",
  fill: "#002645"
}, React.createElement("g", {
  id: "X-Icon",
  transform: "translate(23.000000, 167.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(10.005301, 9.505036) rotate(-315.000000) translate(-10.005301, -9.505036) translate(-2.603394, -2.473225)"
}, React.createElement("polygon", {
  id: "Path",
  points: "13.9130435 10.7391304 25.2173913 10.7391304 25.2173913 14.0434783 13.9130435 14.0434783 13.9130435 23.9565217 10.4347826 23.9565217 10.4347826 14.0434783 4.54747351e-13 14.0434783 4.54747351e-13 10.7391304 10.4347826 10.7391304 10.4347826 0 13.9130435 0"
})))));

var SvgReject = function SvgReject(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reject.5342fcd2.svg";
export { ForwardRef as ReactComponent };